
import React, { useState , useEffect} from "react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { ToastContainer, toast, Zoom } from 'react-toastify';
import step1 from "../../assets/web/images/step-1.png";
import step2 from "../../assets/web/images/step-2.png";
import selfie from "../../assets/web/images/selfie.jpg";
const  Howtouploadselfie = (props) => {
return (
    <>  
      <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
             <h4> How to upload a selfie? A step-by-step guide.</h4> 
             
            </Modal.Title>
          </Modal.Header>
              <Modal.Body>

              <section className="ivo-section upload-image-detail">
   <div className="container">
      <div className="how-to-upload">
        
         <div className="text-box">
            <div className="uploading-steps">
               <div className="mb-3">
                  <p>
                     1. Select Your Document <span className="rotate-icon"><i
                        className="fa-solid fa-arrow-right"></i></span>
                  </p>
                  <div className="uploading-sub-heading">Use a Valid Document</div>
               </div>
               <div className="img-box text-center">
                  <img className="img-fluid" src={step1} alt="" />
               </div>
            </div>
            <div className="uploading-steps">
               <div className="mb-3">
                  <p>
                     2. Fill Your ID Number <span className="rotate-icon"><i
                        className="fa-solid fa-arrow-right"></i></span>
                  </p>
                  <div className="uploading-sub-heading">Enter the number of the selected document</div>
               </div>
               <div className="img-box text-center">
                  <img className="img-fluid" src={step2} alt="" />
               </div>
            </div>
            <div className="uploading-steps">
               <div className="mb-3">
                  <p>
                     3. Upload Your Selfie <span className="rotate-icon"><i
                        className="fa-solid fa-arrow-right"></i></span>
                  </p>
               </div>
               <div className="row align-items-center">
                  <div className="col-lg-2 col-md-2">
                     <div className="img-box">
                        <img className="img-fluid" src={selfie}  alt="" />
                     </div>
                  </div>
                  <div className="col-lg-10 col-md-10">
                     <div className="img-box selfie-points">
                        <ul>
                           <li className="pricng-middle-content ivo-ovrflow-hidden">
                              <span className="d-flex"> <span className="right-icon"><i className="fa-solid fa-check"></i></span>Take
                              A Selfie Of Your With A Neutral
                              Expression</span>
                           </li>
                           <li className="pricng-middle-content ivo-ovrflow-hidden">
                              <span className="d-flex"> <span className="right-icon"><i className="fa-solid fa-check"></i></span>Make
                              Sure Your Whole Face Is Visible. Centered and Your Eyes Are Open</span>
                           </li>
                           <li className="pricng-middle-content ivo-ovrflow-hidden">
                              <span className="d-flex"> <span className="wrong-icon right-icon"><i
                                 className="fa-solid fa-xmark"></i></span>Do Not Crop Your ID Of Use
                              Screenshot Of Your ID</span>
                           </li>
                           <li className="pricng-middle-content ivo-ovrflow-hidden">
                              <span className="d-flex"> <span className="wrong-icon right-icon"><i
                                 className="fa-solid fa-xmark"></i></span>Do Not Hide Or Alter Part
                              Of Your Face <span><strong> (No Hats/beauty
                              images/filters)</strong></span></span>
                           </li>
                        </ul>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</section>

              </Modal.Body>
             
        </Modal>       
    </>

  );
}

export default Howtouploadselfie;
